// ** Redux Imports
import { combineReducers } from 'redux';

// ** Reducers Imports
import auth from './auth';
import navbar from './navbar';
import layout from './layout';
import dataTables from './dataTable';
import view from './view';
import terminals from './terminal';
import forms from './forms';
import accounts from './accounts';
import wallets from './wallets';
import transactions from './transactions';
import tickets from './tickets';
import notfications from './notifs';
import userInfo from './setting';
import settlements from './settllements';
import dashboard from './dashboard';
import userProfile from './profile';
import userRegisterInfo from './authenticate';
import notificationsPage from './notificationsPage';
import affiliates from './affiliation';
import commissionBack from './commissionBack';
import formAction from './formAction';
import branches from './branches';
import messageWalletTransactions from './messageWalletTransactions';
import userServices from './profile/userServices';

const rootReducer = combineReducers({
  auth,
  navbar,
  layout,
  dataTables,
  view,
  terminals,
  forms,
  accounts,
  wallets,
  transactions,
  tickets,
  notfications,
  userInfo,
  settlements,
  dashboard,
  userProfile,
  userRegisterInfo,
  notificationsPage,
  affiliates,
  commissionBack,
  messageWalletTransactions,
  formAction,
  userServices,
  branches,
});

export default rootReducer;
